module.exports = __webpack_public_path__ + "img/star-map_bg-4.77f639c.png";